module.exports = {
  host: "http://localhost:3000",
  prod_host: "http://3.108.31.177/api"
};
